import apiClient from "./api";
class UserService{
 
      async Login(postData: any) { 
        try {
        const response = await apiClient.post("/user/login", postData); 
        return response.data;
          
        } catch (err) {
          
        }
      }
      async RegisterUser(postData: any) { 
        try {
        const response = await apiClient.post("/user/register", postData); 
        return response.data;
          
        } catch (err:any) {
          if(err?.response?.data?.message=="A user is already reigstered with this email address.")
            return "email already exists";
          return "error";
        }
      }
      async ConfirmRegistration(registerCode: string, email: string) { 
        try {
        const response = await apiClient.get("/user/register/"+registerCode+"/"+email); 
          return true;
        } catch (err:any) {
          return false;
        }
      }

      async ResendConfirmationEmail( email: string) { 
        try {
        const response = await apiClient.get("/user/resend-verification-email/"+email); 
          return true;
        } catch (err:any) {
          return false;
        }
      }

      async GetRefreshToken(guid:any) { 
        try {
          const response = await apiClient.get("/User/refresh-token/"+guid);
        
        return response.data;
          
        } catch (err) {
        }
      }

      async ChangePassword(postData: any) {
        // Unlike the other methods here the caller needs to tell a wrong current
        // password apart from a general failure, so the server error is surfaced
        // instead of being collapsed into false / "error".
        const response = await apiClient.post("/user/change-password", postData);
        return response.data;
      }

      async CreateDentist(postData: any) {
        // Like ChangePassword, the server error is surfaced so the admin sees
        // why the dentist couldn't be created (e.g. the email is already registered).
        const response = await apiClient.post("/Admin/dentist", postData);
        return response.data;
      }

      async PostSignature(postData:any) {
        try {
          const response = await apiClient.post("/user/signature", postData); 
        
        return response.data;
          
        } catch (err) {
        }
      }
}
export default new UserService();